module.exports = __webpack_public_path__ + "static/dance_768-736152273090e20bbeb7cf9f1cbe038a.mp4";